
















































import Vue, { VueConstructor } from 'vue';
import { AxiosResponse, AxiosError } from 'axios';
import { UserInformation, LoginInformation, LoginStatesOptions } from '../../../models';
import { ToastMessage } from '../../../plugins/toast/models/message';
import vmLogin from '../mappers';
import services from '../../../services';
import lang from '../../../common/lang/de';
import { TokenHelper } from '../../../common/utils/TokenHelper';

const { LoginService } = services;

export default (Vue as VueConstructor<
  Vue & {
    $refs: {
      form: HTMLFormElement;
    };
  }
>).extend({
  name: 'LoginForm',
  data() {
    return {
      loginVm: vmLogin.createLoginVm(),
      valid: false,
      isUserForm: true as boolean,
      passwordRules: [v => !!v || 'Password is required'],
      userNameRules: [v => !!v || 'Username is required'],
    };
  },
  methods: {
    clear() {
      this.$refs.form.reset();
    },
    submitForm() {
      this.loginWithCredentials();
    },
    loginWithCredentials() {
      this.$loader.show();
      const data = vmLogin.mapLoginVmToLoginDto(this.loginVm);
      LoginService.loginByUserPass(data)
        .then((result: AxiosResponse<LoginInformation>) => {
          const item = result.data;
          TokenHelper.saveToken(item.token, item.url);
          this.$store.dispatch('user/setUser', TokenHelper.getUserInformation());
          this.handleLoginResult(this.$store.state.user.user);
          this.$loader.hide();
        })
        .catch((err: AxiosError) => {
          this.$loader.hide();
          this.sendLoginError(LoginStatesOptions.UnexpectedError);
        });
    },
    handleLoginResult(userInformation: UserInformation) {
      if (userInformation.token.state == LoginStatesOptions.Success) {
        if (userInformation.token.isCustomer === true) {
          this.$emit('loginSuccess', userInformation.token.debtorNumber);
        } else {
          this.$emit('loginSuccessCallCenter');
        }
      } else if (userInformation.token.state == LoginStatesOptions.Locked) {
        this.$router.push({
          name: 'Locked',
        });
      } else {
        this.sendLoginError(userInformation.token.state);
        TokenHelper.deleteToken();
      }
    },
    sendLoginError(id: LoginStatesOptions) {
      const toast = {} as ToastMessage;
      toast.message = 'Error without message handler';
      switch (id) {
        case LoginStatesOptions.FailedlUserPass:
          toast.header = lang.login.error.failedUserPass.header;
          toast.message = lang.login.error.failedUserPass.message;
          break;
        case LoginStatesOptions.OsaIdMissing:
          toast.header = lang.global.error.NotAuthorized.header;
          toast.message = lang.global.error.NotAuthorized.message;
          break;
        case LoginStatesOptions.CloudServiceException:
          toast.message = lang.login.error.cloudServiceException;
          break;
        case LoginStatesOptions.InvalidUsername:
          toast.header = lang.global.error.NotAuthorized.header;
          toast.message = lang.global.error.NotAuthorized.message;
          break;
        default:
          toast.header = lang.global.error.unerwarteter.header;
          toast.message = lang.global.error.unerwarteter.message;
          break;
      }
      this.$emit('loginError', toast);
    },
  },
});
